<template>
  <div class="reason-picker">
    <h2 class="h3 mb-2"><b>Quick question first</b></h2>
    <p class="text-muted mb-4">What's making you cancel today?</p>

    <div class="reason-picker__list mb-3">
      <label
        v-for="reason in CANCEL_REASONS"
        :key="reason.slug"
        class="reason-picker__option"
        :class="{ 'reason-picker__option--selected': reason.slug === selected }"
      >
        <input
          type="radio"
          class="form-check-input me-2"
          :value="reason.slug"
          :checked="reason.slug === selected"
          @change="onSelect(reason.slug)"
        />
        {{ reason.label }}
      </label>
    </div>

    <textarea
      class="form-control"
      rows="3"
      placeholder="Anything else we're missing?"
      :value="otherText"
      @input="$emit('update:otherText', ($event.target as HTMLTextAreaElement).value)"
    ></textarea>
  </div>
</template>

<script setup lang="ts">
import { CANCEL_REASONS, type CancelReasonSlug } from "../../subscriptionLogic";

defineProps<{ selected: CancelReasonSlug | null; otherText: string }>();
const emit = defineEmits<{
  (e: "update:selected", slug: CancelReasonSlug): void;
  (e: "update:otherText", text: string): void;
  (e: "not-working-selected"): void;
}>();

function onSelect(slug: CancelReasonSlug) {
  emit("update:selected", slug);
  if (slug === "not_working") emit("not-working-selected");
}
</script>

<style scoped lang="scss">
.reason-picker {
  &__list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__option {
    display: flex;
    align-items: center;
    padding: 0.85rem 1rem;
    border-radius: 12px;
    border: 2px solid var(--gray-border, #434343);
    cursor: pointer;
    margin: 0;

    &--selected {
      border-color: var(--yellow, #ffd700);
      background-color: rgba(255, 215, 0, 0.1);
    }
  }
}
</style>
